import Vue from 'vue'
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import VeeValidate from 'vee-validate'

// Add favicons (for build)
require.context('./assets/favicons', true, /^\.\//);

Vue.use(VueScrollTo)
Vue.use(VeeValidate, {
  delay: 100,
  locale: 'en',
  dictionary: {
    en: {
      messages: {
        email: (field) => `Must be a valid email`,
        required: (field) => `Field is required`
      }
    }
  },
  strict: true,
})

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js